export enum MetaltrackJobStatus{
    InProgress = 'InProgress',
    Completed = 'Completed',
}